/** @format */

import React, { FunctionComponent, useState } from 'react'
import styled from 'styled-components'
import { HashRouter, Switch, Route, Redirect, useHistory } from 'react-router-dom'
import { Layout, Body } from 'kpc-react/components/layout'
import SiderBar from './components/SiderBar/index'
import MonitorGeneral from './pages/MonitorGeneral'
import MonitorMenu from './pages/MonitorMenu'
import MonitorCloudChart from './pages/MonitorCloud/MonitorCloudChart'
import MonitorCloudList from './pages/MonitorCloud/MonitorCloudList'
import MonitorClouOuterView from './pages/MonitorCloud/MonitorClouOuterView'
import MonitorAlarmTactics from './pages/MonitorAlarm/MonitorAlarmTactics'
import MonitorAlarmHistory from './pages/MonitorAlarm/MonitorAlarmHistory'
import MonitorCreate from 'src/containers/MonitorCreate'
import MonitorAlarming from './pages/MonitorAlarm/MonitorAlarming'
import EventConter from './pages/EventCenter'
import CustommonitorAlarm from './pages/MonitorCustommonitor/CustommonitorAlarm'
import CustommonitorTarget from './pages/MonitorCustommonitor/CustommonitorTarget'
import AlarmEventDetail from 'src/pages/MonitorAlarm/MonitorAlarmHistory/AlarmEventDetail'
import TacticsDetail from 'src/pages/MonitorAlarm/MonitorAlarmHistory/TacticsDetail'
import MonitorContacts from './pages/MonitorContacts'
import MonitorGroup from './pages/MonitorGroup'
import MonitorGroupDetails from './pages/MonitorGroup/GroupDetails'
import MonitorDashboard from './pages/MonitorDashboard'
import CustomboardPage from './pages/MonitorDashboard/Customboard/CustomboardPage'
import CustomboardGraphEditPage from './pages/MonitorDashboard/Customboard/CustomboardGraphEditPage'
import CustomRoute from './components/CustomRoute'
// import TestPage from './TestPage'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import useGlobalData from 'src/hooks/useGlobalData'

const App: FunctionComponent<any> = ({ className }, props) => {
  const [menuState, setMenuState] = useState(false)
  const isSelf = window.self === window.top
  const productMenu = useGlobalData('productMenu')
  return (
    <HashRouter
      basename={window?.['__POWERED_BY_QIANKUN__'] ? '/ksc-monitor-web' : '/'}
      hashType="hashbang"
    >
      {productMenu?.length ? (
        <Layout className={`${className} ksc-monitor-third-btn`}>
          {isSelf ? <SiderBar menuState={menuState} setMenuState={setMenuState} /> : null}
          <Body className={isSelf && !menuState ? 'monitor-body' : 'monitor-body monitor-body-out'}>
            <Switch>
              {/* 概览 */}
              <CustomRoute
                exact
                path="/monitor/generalview/home"
                component={MonitorGeneral}
              ></CustomRoute>
              {/* 云服务类别 */}
              <Route exact path="/monitor/menu" component={MonitorMenu}></Route>
              <Route exact path="/monitor/list/:name" component={MonitorCloudList}></Route>
              {/* 云服务类别-图表页 */}
              <CustomRoute
                exact
                path={[
                  // eslint-disable-next-line max-len
                  '/monitor/list/overview/:productType/:instanceId/:instanceName/:topType/:regionName',
                  // eslint-disable-next-line max-len
                  '/monitor/list/overview/:instanceName/:instanceId/:productType/:page/:prdocutName/:regionName',
                  // eslint-disable-next-line max-len
                  '/monitor/list/overview/:instanceName/:instanceId/:productType/:page/:prdocutName/:regionName/:topType'
                ]}
                component={MonitorCloudChart}
              ></CustomRoute>
              {/* 云服务类别-图表页-外部跳转 */}
              <CustomRoute
                exact
                path={[
                  // eslint-disable-next-line max-len
                  '/monitor/detail/:instanceName/:instanceId/:page/:regionName',
                  // eslint-disable-next-line max-len
                  '/monitor/detail/:instanceName/:instanceId/:page/:regionName/:productType'
                ]}
                component={MonitorClouOuterView}
              ></CustomRoute>
              {/* 自定义监控-指标 */}
              <CustomRoute
                exact
                path={[
                  '/monitor/custom/metric',
                  '/monitor/custom/metric/:region/:namespace/:metricKey/:dimension'
                ]}
                component={CustommonitorTarget}
              ></CustomRoute>

              {/* 自定义监控-告警 */}
              <CustomRoute
                exact
                path="/monitor/custom/alarm"
                component={CustommonitorAlarm}
              ></CustomRoute>
              {/* 自定义监控-事件中心 */}
              <CustomRoute
                exact
                path="/monitor/systomcenter/home"
                component={EventConter}
              ></CustomRoute>
              {/* 告警策略-告警历史 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/history/detail/event/:policyName"
                component={AlarmEventDetail}
              ></CustomRoute>
              {/* 告警策略-告警历史 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/history/detail/:policyId/:policyName"
                component={TacticsDetail}
              ></CustomRoute>
              {/* 告警策略 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/rule/home"
                component={MonitorAlarmTactics}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/alarmServer/history/home"
                component={MonitorAlarmHistory}
              ></CustomRoute>
              <CustomRoute
                path={[
                  `/monitor/alarmServer/rule/create/:productType`,
                  '/monitor/alarmServer/rule/create',
                  '/monitor/alarmServer/rule/detail/:policyId',
                  '/monitor/alarmServer/rule/detail/:policyId/:resourceBindType'
                  // `/monitor/alarmServer/tactics/edit/:id/:productType`,
                  // `/monitor/alarmServer/tactics/edit/:id`
                ]}
                component={MonitorCreate}
              ></CustomRoute>
              <CustomRoute
                exact
                path={[
                  '/monitor/alarmServer/alarming/home',
                  '/monitor/alarmServer/alarming/home/:productType'
                ]}
                component={MonitorAlarming}
              ></CustomRoute>
              {/* 联系人管理 */}
              <CustomRoute path="/monitor/linkman/home" component={MonitorContacts}></CustomRoute>
              {/* 资源组管理 */}
              <CustomRoute exact path="/monitor/group/home" component={MonitorGroup}></CustomRoute>
              {/* 资源组管理-详情管理*/}
              <CustomRoute
                path="/monitor/group/details/:groupId/:groupName"
                component={MonitorGroupDetails}
              ></CustomRoute>
              {/* dashboard */}
              <CustomRoute
                exact
                path="/monitor/dashboard/home"
                component={MonitorDashboard}
              ></CustomRoute>
              {/* dashboard-详情*/}
              <CustomRoute
                exact
                path="/monitor/dashboard/detail/private/:id"
                component={CustomboardPage}
              ></CustomRoute>
              {/* dashboard-详情-编辑*/}
              <CustomRoute
                exact
                // eslint-disable-next-line max-len
                path="/monitor/dashboard/detail/editGraph/:dashboardId/:dashboardName/:graphId"
                component={CustomboardGraphEditPage}
              ></CustomRoute>
              {/* <CustomRoute exact path="/monitor/test" component={TestPage}></CustomRoute> */}
              <Redirect from="/monitor/rule" to="/monitor/alarmServer/rule/home" />
              <Redirect from="/" to="/monitor/generalview/home" />
            </Switch>
          </Body>
        </Layout>
      ) : null}
    </HashRouter>
  )
}

export default styled(App)`
  width: 100%;
  height: calc(100% - 50px);
  .monitor-body {
    margin-left: 200px;
    transition: all 0.3s ease-out;
  }
  .monitor-body-out {
    margin-left: 18px;
  }
`
